import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import Grid from '@mui/material/Grid2';


import CameraAltIcon from '@mui/icons-material/CameraAlt';


import axios from "axios";
import Swal from 'sweetalert2';

import { TextField } from '@mui/material';

const StyledFab = styled(Fab)({
    position: 'absolute',
    zIndex: 1,
    top: -30,
    left: 0,
    right: 0,
    margin: '0 auto',
});

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

function ModalArticulo(params) {
    axios.defaults.withCredentials = true;

    const base = {
        "area": "",
        "ancho": "",
        "alto": "",
        "datos": "",
        "proyecto_id": params.id_proyecto
    }


    const [articulo, setArticulo] = React.useState({
        "area": "",
        "ancho": "",
        "alto": "",
        "datos": "",
        "proyecto_id": 0
    });

    const [imageFile, setImageFile] = React.useState(null); // Estado para almacenar la imagen
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        let tempArticulo = { ...articulo };
        tempArticulo.proyecto_id = params.id_proyecto;
        setArticulo(tempArticulo);
    }, [params.id_proyecto]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCancelar = () => {
        handleClose();
        setArticulo(base);
        setImageFile(null)
    }

    const handleChangeData = (e) => {
        let tempArticulo = { ...articulo };
        switch (e.target.name) {
            case "proyecto":
                tempArticulo.area = e.target.value;
                break;
            case "ancho":
                tempArticulo.ancho = e.target.value;
                break;
            case "largo":
                tempArticulo.alto = e.target.value;
                break;
            case "extra":
                tempArticulo.datos = e.target.value;
                break;
            default:
                break;
        }
        setArticulo(tempArticulo);
    }

    const handleImageChange = (e) => {
        setImageFile(e.target.files[0]); // Almacena el archivo de imagen
    };

    const handleSaveArticulo = () => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Vas a guardar un nuevo elemento",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'GUARDAR',
        }).then((result) => {
            if (result.isConfirmed) {
                // El usuario hizo clic en "Sí"
                guardarArticulo();
            } else {
                // El usuario hizo clic en "No"
                Swal.fire({
                    title: 'Accion Cancelada',
                    icon: 'error',
                    text: "",
                    showConfirmButton: false,
                    timer: 1000
                });
            }
        });
    }

    const guardarArticulo = async () => {
        try {
            const response = await axios.post(
                "https://apimedidas.ahouseinterior.com/agregar_articulo.php",
                articulo,
                { headers: { "Content-Type": "application/json" } }
            );

            // Verifica y almacena los datos recibidos
            if (response.data && response.data.status === "success") {
                // Aquí podrías almacenar el ID del artículo guardado si es necesario
                const articuloId = response.data.articulo.id;

                // Subir la imagen solo si el artículo se guardó correctamente
                if (imageFile) {
                    await uploadImage(articuloId);
                } else {
                    params.handleChargeProyect(params.id_proyecto, "Articulo Guardado");
                    handleClose();
                    setArticulo(base)
                    setImageFile(null)
                }
            } else {
                Swal.fire({
                    title: 'Error',
                    text: response.data.message ? response.data.message : "No se pudo guardar.",
                    icon: 'error',
                    showConfirmButton: false,
                    timer: 1000
                });
            }
        } catch (err) {
            Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error al conectar con el servidor.',
                icon: 'error',
                showConfirmButton: false,
                timer: 1000
            });
        }
    };

    const uploadImage = async (articuloId) => {
        const formData = new FormData();
        formData.append("imagen", imageFile); // Agrega la imagen al formulario
        formData.append("articulo_id", articuloId); // Agrega el ID del artículo

        Swal.fire({
            title: 'Guardando...',
            didOpen: () => {
                Swal.showLoading();
            },
            allowOutsideClick: false,
            showConfirmButton: false,
        });

        try {
            const response = await axios.post(
                "https://apimedidas.ahouseinterior.com/subir_imagen.php",
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (response.data && response.data.status === 'success') {
                Swal.fire({
                    title: 'Artículo Guardado',
                    icon: 'success',
                    text: "",
                    showConfirmButton: false,
                    timer: 1000,
                });
                params.handleChargeProyect(params.id_proyecto, "Artículo Guardado");
                handleClose();
                setImageFile(null);
                setArticulo(base);
            } else {
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    text: response.data.message || "La imagen no se guardó.",
                    showConfirmButton: false,
                    timer: 1000,
                });
            }
        } catch (err) {
            Swal.fire({
                title: 'Error',
                icon: 'error',
                text: "Ocurrió un error al subir la imagen.",
                showConfirmButton: false,
                timer: 1000,
            });
        } finally {
            Swal.close();
        }
    };




    return (
        <React.Fragment>
            <StyledFab color="success" aria-label="add" onClick={handleClickOpen}>
                <AddIcon />
            </StyledFab>
            <Dialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                disableRestoreFocus
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Agregar Elemento
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Grid container spacing={2} rowSpacing={2} columns={10}>
                        <Grid size={{ xs: 10, md: 5 }}>
                            <TextField
                                fullWidth
                                name='proyecto'
                                label='Area'
                                variant='outlined'
                                value={articulo.area}
                                onChange={handleChangeData}
                            />
                        </Grid>
                        <Grid size={{ xs: 10, md: 5 }}>
                            <TextField
                                fullWidth
                                name='ancho'
                                label='Ancho'
                                variant='outlined'
                                type='number'
                                value={articulo.ancho}
                                onChange={handleChangeData}
                            />
                        </Grid>
                        <Grid size={{ xs: 10, md: 5 }}>
                            <TextField
                                fullWidth
                                name='largo'
                                label='Largo'
                                variant='outlined'
                                type='number'
                                value={articulo.alto} // Cambiado a 'alto' para que coincida
                                onChange={handleChangeData}
                            />
                        </Grid>
                        <Grid size={{ xs: 10, md: 5 }}>
                            <TextField
                                fullWidth
                                name='extra'
                                label='Datos Extra'
                                variant='outlined'
                                value={articulo.datos}
                                onChange={handleChangeData}
                            />
                        </Grid>
                        <Grid size={{ xs: 10, md: 5 }}>
                            <Button
                                fullWidth
                                component="label"
                                role={undefined}
                                tabIndex={-1}
                                color={imageFile ? "success" : "warning"}
                                variant={imageFile ? "outlined" : "contained"}
                                startIcon={<CameraAltIcon />}
                            >
                                {imageFile &&
                                    "Imagen Cargada"
                                }
                                {!imageFile &&
                                    "Cargar Imagen"
                                }
                                <VisuallyHiddenInput
                                    type="file"
                                    onChange={handleImageChange}
                                    name='imagen'
                                />
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "space-between" }}>
                    <Button variant='outlined' color="error" onClick={handleCancelar}>
                        Cancelar
                    </Button>
                    <Button variant='contained' onClick={handleSaveArticulo}>
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default ModalArticulo;
